import React, {Component} from 'react';
import {connect} from 'react-redux';

import LoadingBar from 'react-redux-loading-bar';

import SvgIcon from 'common/components/SvgIcon';

import {
    loginUser,
    actionUser
} from '../../actions/login';

import './LoginContainer.less';

import LoginForm from '../../components/LoginForm';
import ActivateForm from '../../components/ActionForm';
import ForgotForm from '../../components/ForgotForm';

class LoginContainer extends Component {

    handleLogin = (data) => {
        this.props.dispatch(loginUser(data));
    };

    handleAction = ({password2, ...data}) => {
        const { dispatch, code, action } = this.props;

        dispatch(actionUser({
            ...data,
            code
        }, action));
    };

    render() {

        const { email, request, code, action, status } = this.props;

        return (
            <div className="LoginContainer">
                <LoadingBar className="LoginContainer-loader" />
                <div className="LoginContainer-inner">
                    <div className="LoginContainer-logo">
                        <SvgIcon namespace="control" icon="logo-header" />
                    </div>
                    <h1>Content management system</h1>
                    {!code && !action &&
                        <LoginForm onSubmit={this.handleLogin}/>
                    }
                    {action && code &&
                        <ActivateForm email={email} onSubmit={this.handleAction} />
                    }
                    {action && action === 'forgot' && !code &&
                        <ForgotForm email={email} status={status} onSubmit={this.handleAction} />
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    const {
        email, request, status
    } = state.login;

    const { match: { params: { code, action } }, history } = ownProps;

    return {
        email, request, code, action, status, history
    };
};

export default connect(
    mapStateToProps
)(LoginContainer);



// WEBPACK FOOTER //
// ./assets/app/login/containers/LoginContainer/LoginContainer.jsx